<script lang="ts">
  import type { LoginFormHandler } from '@athena-lib/LoginForm';
  import CreateAccount from './CreateAccount.svelte';
  import Login from './Login.svelte';
  import ResetPassword from './ResetPassword.svelte';

  type Props = {
    onLogin: LoginFormHandler;
    onResetPassword: LoginFormHandler;
    onCreateAccount: LoginFormHandler;
    googleLoginHref: string;
  };

  type Screen = 'login' | 'reset_password' | 'create_account';

  const { onLogin, onCreateAccount, onResetPassword, googleLoginHref }: Props = $props();

  let screen = $state<Screen>('login');

  const goToLogin = () => (screen = 'login');
  const goToResetPassword = () => (screen = 'reset_password');
  const goToCreateAccount = () => (screen = 'create_account');
</script>

<div class="px-5 pb-5 pt-14">
  {#if screen === 'login'}
    <Login {onLogin} {goToResetPassword} {goToCreateAccount} {googleLoginHref} />
  {:else if screen === 'reset_password'}
    <ResetPassword {goToLogin} {onResetPassword} />
  {:else if screen === 'create_account'}
    <CreateAccount {goToLogin} {onCreateAccount} />
  {/if}
</div>
